import { Navigate, useParams } from 'react-router-dom'
import { routeNames } from 'src/modules/core/constants/routeNames'

/**
 * Redirects from legacy /bookings/:bookingId/reschedule to /reschedule/:urlCode
 * so old links continue to work.
 */
export function RedirectToReschedule() {
  const { bookingId } = useParams<{ bookingId: string }>()
  const urlCode = bookingId ?? ''
  const to = routeNames.reschedule.path.replace(':urlCode', urlCode)
  return <Navigate to={to} replace />
}
